import React, { useEffect, useState } from "react";
import Filter from "components/Filter";
import Table from "components/Table";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import eightAxios from "../../configs/axiosConfig";
import FileDownload from "js-file-download";
import { useNotifyContext } from "@Components/Notify";

const pageNumberDropdown = true;
const today = new Date();
const options = { timeZone: 'Asia/Kuala_Lumpur' };
let date = today.toLocaleDateString('en-GB', options);
date = date.split('/').reverse().join('-');
const filterInitialValues = {
  date: date,
};

let model = [
  { id: "date", label: "Date", type: "string" },
  { id: "file_name", label: "File", type: "loading" },
  { id: "type", label: "Type", type: "string" },
];

const ERMLList = () => {
  const setNotify = useNotifyContext();
  const [filterValues, setFilterValues] = useState(null);
  const [downloadId, setDownloadId] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const filterFields = [
    {
      type: "datepicker",
      label: "File Date",
      name: "date",
      emptyLabel: "DD/MM/YYYY",
    },
  ];

  const onFilterRequest = (values) => {
    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };

  const downloadLedger = (id, record) => {
    let tempArray = downloadId.slice();
    tempArray.push(id);
    setDownloadId(tempArray);
    eightAxios
      .post("/erml-file/download/", { date: record.date, type: record.type })
      .then((response) => {
        let fileName = record.file_name;
        if (response.status === 200) {
          FileDownload(response.data, fileName);
        }
      })
      .catch(() => {
        setNotify({
          isOpen: true,
          message: "Failed to download the record",
          type: "error",
        });
      })
      .finally(() => {
        let anotherTempArray = downloadId.slice();
        anotherTempArray.splice(anotherTempArray.indexOf(id), 1);
        setDownloadId(anotherTempArray);
      });
  };

  const actions = [
    {
      type: "export",
      title: "Download",
      icon: <CloudDownloadIcon style={{ color: "red" }} />,
      onClick: (id, record) => downloadLedger(id, record),
    },
  ];

  useEffect(() => {
    setRefresh(!refresh);
  }, [downloadId, downloadId.length]);

  return (
    <div>
      <Filter
        initialValues={filterInitialValues}
        filterFields={filterFields}
        onSubmit={onFilterRequest}
      />
      <Table
        proxyURL="/erml-file/"
        model={model}
        actions={actions}
        filterValues={filterValues || filterInitialValues}
        noFilter
        noAddButton
        downloadId={downloadId}
        pageNumberDropdown={pageNumberDropdown}

        // refresh={refresh}
      />
    </div>
  );
};

export default ERMLList;
